var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowedUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1309 16.166C30.1309 20.5757 26.6292 24.1504 22.3096 24.1504C17.99 24.1504 14.4883 20.5757 14.4883 16.166C14.4883 11.7564 17.99 8.18164 22.3096 8.18164C26.6292 8.18164 30.1309 11.7564 30.1309 16.166Z",
    stroke: "#710D10",
    strokeWidth: 3.54041,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7271 11.4546L40.9642 19.6364L37.6362 16.8475",
    stroke: "#710D10",
    strokeWidth: 3.02727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0913 31.2271C26.1286 31.2271 29.6968 32.1783 32.1948 33.6245C34.7388 35.0974 35.8638 36.8681 35.8638 38.4546C35.8638 40.0411 34.7388 41.8118 32.1948 43.2847C29.6968 44.7308 26.1286 45.6821 22.0913 45.6821C18.0538 45.6821 14.485 44.7309 11.9868 43.2847C9.44279 41.8118 8.31787 40.0411 8.31787 38.4546C8.31787 36.8681 9.44279 35.0974 11.9868 33.6245C14.485 32.1783 18.0538 31.2271 22.0913 31.2271Z",
    stroke: "#710D10",
    strokeWidth: 3.54471
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1309 16.166C30.1309 20.5757 26.6292 24.1504 22.3096 24.1504C17.99 24.1504 14.4883 20.5757 14.4883 16.166C14.4883 11.7564 17.99 8.18164 22.3096 8.18164C26.6292 8.18164 30.1309 11.7564 30.1309 16.166Z",
    fill: "#710D10",
    stroke: "#710D10",
    strokeWidth: 3.54041,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0913 31.2271C26.1286 31.2271 29.6968 32.1783 32.1948 33.6245C34.7388 35.0974 35.8638 36.8681 35.8638 38.4546C35.8638 40.0411 34.7388 41.8118 32.1948 43.2847C29.6968 44.7308 26.1286 45.6821 22.0913 45.6821C18.0538 45.6821 14.485 44.7309 11.9868 43.2847C9.44279 41.8118 8.31787 40.0411 8.31787 38.4546C8.31787 36.8681 9.44279 35.0974 11.9868 33.6245C14.485 32.1783 18.0538 31.2271 22.0913 31.2271Z",
    fill: "#710D10",
    stroke: "#710D10",
    strokeWidth: 3.54471
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowedUserIcon);
export default __webpack_public_path__ + "static/media/followed-user-icon.356b5c2b34755176ff4b4f5e6acb9f27.svg";
export { ForwardRef as ReactComponent };